var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeed3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_667_10427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5106 48.6531L28.5083 48.1554H28.0106H16.049C13.9068 48.1554 12.7568 45.6373 14.1596 44.0183L49.3944 3.35422V31.43V31.93H49.8944H59.6856C62.6819 31.93 64.2929 35.4498 62.3345 37.7176L28.6398 76.7349L28.5106 48.6531Z",
    fill: "#1D3C8A",
    stroke: "#1D3C8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7074 48.6531L24.7051 48.1554H24.2074H14.4354C11.4363 48.1554 9.82632 44.63 11.7903 42.3635L45.5912 3.35422V31.43V31.93H46.0912H55.8824C58.8787 31.93 60.4897 35.4498 58.5313 37.7176L24.8365 76.7349L24.7074 48.6531Z",
    fill: "white",
    stroke: "#1D3C8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8857 2.01364H46.0874V6.76727L49.8857 2.01364Z",
    fill: "#1D3C8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3373 78.0718H28.1533V73.1802L24.3373 78.0718Z",
    fill: "#1D3C8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3312 9.41421L58.0054 8.77187C57.5966 8.65897 57.5098 8.11783 57.8629 7.88282L66.6544 2.03014L65.1768 7.38048L67.1574 7.9275C67.702 8.0779 67.8181 8.79845 67.3483 9.11229L58.8781 14.7713L60.3312 9.41421Z",
    fill: "#6CE2E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5161 22.31L67.5619 21.0343C67.0427 20.8101 67.0275 20.0794 67.537 19.8338L80.2248 13.7179L77.2902 20.5137L79.8059 21.6001C80.4976 21.8988 80.5186 22.8719 79.8405 23.2002L67.6127 29.1193L70.5161 22.31Z",
    fill: "#6CE2E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_667_10427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed3);
export default __webpack_public_path__ + "static/media/speed-3.228dfc42b67146d425ab3ae9d5d295ca.svg";
export { ForwardRef as ReactComponent };